import { Action, createReducer, on } from '@ngrx/store';
import { CrudState } from '@wdx/clmi/api-services/models';
import { NudgeType } from '@wdx/clmi/clmi-swagger-gen';
import * as nudgeTypesActions from './nudge-types.actions';

export type State = CrudState<NudgeType>;

export const initialState: State = {};

const reducerSetup = createReducer(
    initialState,

    on(
        nudgeTypesActions.getAll,
        (state): State => ({
            ...state,
            isLoadingList: true,
            hasLoadingListError: false,
        }),
    ),

    on(
        nudgeTypesActions.getAllSuccess,
        (state, props): State => ({
            ...state,
            isLoadingList: false,
            list: props.nudgeTypes,
        }),
    ),

    on(
        nudgeTypesActions.getAllFailure,
        (state): State => ({
            ...state,
            isLoadingList: false,
            hasLoadingListError: true,
        }),
    ),
);

export function reducer(state: State | undefined, action: Action) {
    return reducerSetup(state, action);
}
